import { getInputProps, type FieldMetadata } from '@conform-to/react'
import { Field, TextareaField } from '#app/components/forms.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { formatPhoneNumber } from '#app/utils/misc.tsx'

interface InquiryFormFieldsProps {
	fields: {
		firstName: FieldMetadata<string>
		lastName: FieldMetadata<string>
		email: FieldMetadata<string>
		phone: FieldMetadata<string>
		message: FieldMetadata<string | undefined>
	}
	rental: {
		displayPhone?: boolean
		contactPhone?: string | null
		displayEmail?: boolean
		contactEmail?: string | null
	}
}

export function InquiryFormFields({ fields, rental }: InquiryFormFieldsProps) {
	return (
		<div>
			<div className="grid grid-cols-2 gap-4">
				<Field
					labelProps={{ children: 'First Name' }}
					inputProps={{
						...getInputProps(fields.firstName, {
							type: 'text',
						}),
						placeholder: 'First Name',
						autoComplete: 'given-name',
					}}
					errors={fields.firstName.errors}
				/>
				<Field
					labelProps={{ children: 'Last Name' }}
					inputProps={{
						...getInputProps(fields.lastName, {
							type: 'text',
						}),
						placeholder: 'Last Name',
						autoComplete: 'family-name',
					}}
					errors={fields.lastName.errors}
				/>
			</div>

			<Field
				labelProps={{ children: 'Email' }}
				inputProps={{
					...getInputProps(fields.email, {
						type: 'email',
					}),
					placeholder: 'you@example.com',
					autoComplete: 'email',
				}}
				errors={fields.email.errors}
			/>

			<Field
				labelProps={{ children: 'Phone' }}
				inputProps={{
					...getInputProps(fields.phone, { type: 'tel' }),
					placeholder: '(555) 123-4567',
					autoComplete: 'tel',
				}}
				errors={fields.phone.errors}
			/>

			<TextareaField
				labelProps={{ children: 'Message' }}
				textareaProps={{
					...getInputProps(fields.message, {
						type: 'text',
					}),
					placeholder:
						'Let the owner know when you need the rental and any other details...',
					rows: 4,
				}}
				errors={fields.message.errors}
			/>

			{/* Listing contact information */}
			{((rental.displayPhone && rental.contactPhone) ||
				(rental.displayEmail && rental.contactEmail)) && (
				<div className="border-muted bg-muted/30 mb-4 rounded-lg border p-4">
					<h4 className="mb-2 text-sm font-semibold">Contact Information</h4>
					<div className="space-y-1 text-sm">
						{rental.displayPhone && rental.contactPhone && (
							<div className="flex items-center gap-2">
								<Icon name="phone" className="size-4" />
								<a
									href={`tel:${rental.contactPhone}`}
									className="hover:underline"
								>
									{formatPhoneNumber(rental.contactPhone)}
								</a>
							</div>
						)}
						{rental.displayEmail && rental.contactEmail && (
							<div className="flex items-center gap-2">
								<Icon name="envelope-closed" className="size-4" />
								<a
									href={`mailto:${rental.contactEmail}`}
									className="hover:underline"
								>
									{rental.contactEmail}
								</a>
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	)
}
